<template>
  <div class="wrap-messages">
    <h1>{{$t('reports.titleMessages')}}</h1>
    <div class="no-data" v-if="areReportsEmpty">{{$t('reports.noReportedMessages')}}</div>
    <each-message-report
      v-for="report in reports"
      :key="report.rpt_id"
      :report="report"
      @set-report-id="setReportId"
      @ignore="confirmAction(ignoreReportedMessage, $t('reports.ignoreMessageQuestion'), 'Ignore')"
      @delete="confirmAction(deleteReportedMessage, $t('reports.deleteMessageQuestion'))"
      @ban="confirmAction(banUser, $t('reports.banUserQuestion'))"
    ></each-message-report>
  </div>
</template>

<script>
import EachMessageReport from "../../components/admin/reports/EachMessageReport";
import AdminMixin from './adminMixin.js';
import api from "@/api";
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    EachMessageReport
  },
  data () {
    return {
      reports: [],
      reportId: "",
      areReportsEmpty: false
    };
  },
  mounted () {
    this.getReports();
  },
  methods: {
    async getReports () {
      this.startLoading();
        let apiObj = {
          api: api.getReports,
          params: {
            type: "msg",
          },
          onError: () => this.stopLoading()
        }
        const data = await this.apiCall(apiObj);
        this.reports = data.data;

        if (this.reports.length === 0) {
          this.areReportsEmpty = true;
        }
      this.stopLoading();
    },
    setReportId (reportId) {
      this.reportId = reportId;
    },
    async ignoreReportedMessage () {
      await this.callApiShowSuccessMessageGetReports(api.ignoreReportedMessage, this.$t("reports.reportIgnored"));
    },
    async deleteReportedMessage () {
      await this.callApiShowSuccessMessageGetReports(api.deleteReportedMessage, this.$t("reports.messageDeleted"));
    },
    async banUser () {
      await this.callApiShowSuccessMessageGetReports(api.banUser, this.$t("reports.userBanned"));
    },
    async callApiShowSuccessMessageGetReports (callback, successMessage) {
      let apiObj = {
        api: callback,
        params: {
          rpt_id: this.reportId
        },
        onError: () => this.stopLoading()
      }
      this.startLoading();
        if (await this.apiCall(apiObj)) {
          this.showSuccessMessage(successMessage);
          await this.getReports();
        }
      this.stopLoading();
    }
  }
};
</script>

<style scoped lang="scss">
h1 {
  margin: 0;
  margin-bottom: 68px;
  font-size: 30px;
  line-height: 35px;
}
.wrap-messages {
  padding: 3% 15% 3% 3%;
  background-color: #e5e5e5;
}
.material-icons {
  transform: rotate(180deg);
  font-size: 30px;
  position: fixed;
  bottom: 50px;
  right: 50px;
  background-color: white;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  user-select: none;
}
.arrow-enter-active,
.arrow-leave-active {
  transition: opacity 0.5s;
}
.arrow-enter,
.arrow-leave-to {
  opacity: 0;
}
</style>